/* eslint-disable no-unused-vars */
// import { Formik, FormikHelpers } from 'formik';
import React, { useState } from 'react';
import { DefaultTable } from 'src/components';

import { IAddresses } from 'src/interfaces/personal-info';

import { useTranslation } from 'react-i18next';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { MainTitle } from './styles';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
      font: 'normal normal normal 16px sans-serif',
      fontWeight: 'Medium',
    },
  },
  rows: {
    style: {
      font: 'normal normal 16px sans-serif',
      color: '#1B1D35',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      fontWeight: '500',
      justifyContent: 'left',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
    },
  },
  pagination: {
    style: {
      display: 'none',
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const columns = [
  {
    name: 'Address',
    selector: (row: IAddresses) => row.street || '',
    width: '260px',
    cell: (row: IAddresses) => (
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'visible',
          textOverflow: 'clip',
          minWidth: '260px',
        }}
      >
        {row.street}
      </div>
    ),
  },
  {
    name: 'City',
    selector: (row: IAddresses) => row.city || '',
    width: '200px',
  },
  {
    name: 'State',
    selector: (row: IAddresses) => row.state || '',
    width: '100px',
  },
  {
    name: 'Zip Code',
    selector: (row: IAddresses) => row.zipCode || row.postalCode || '',
    width: '150px',
  },
];

const AddressTable: React.FC = () => {
  const { data } = useTypedSelector(state => state.personalInfo);
  const addresses = data.personalInfo?.addresses ?? [];
  const primaryAddresses = addresses.filter(address => address.isPrimary?.toLowerCase() === 'yes');
  const addressInfo = primaryAddresses.length ? primaryAddresses : addresses;
  const { t } = useTranslation();

  return (
    <div style={{ width: '100%' }}>
      <MainTitle>{t('benefits.address.table.header')}</MainTitle>

      <div>
        <DefaultTable columns={columns} data={addressInfo} customStyles={customStyles} />
      </div>
    </div>
  );
};

export default AddressTable;
